function toLocalDateString(str: string): string {
  const options = {
    year: "numeric",
    month: "numeric",
    day: "numeric"
  };
  return new Date(str).toLocaleDateString("nl-NL", options);
}

function toLocalDateTimeString(str: string): string {
  const options = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit"
  };
  return new Date(str).toLocaleDateString("nl-NL", options);
}

export { toLocalDateString, toLocalDateTimeString };
